import { render, staticRenderFns } from "./ReturnItem.vue?vue&type=template&id=35719133&scoped=true&"
import script from "./ReturnItem.vue?vue&type=script&lang=js&"
export * from "./ReturnItem.vue?vue&type=script&lang=js&"
import style0 from "./ReturnItem.vue?vue&type=style&index=0&id=35719133&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35719133",
  null
  
)

export default component.exports